import { jsx as r, jsxs as T } from "react/jsx-runtime";
import { useMultiStyleConfig as B, Popover as E, PopoverAnchor as F, PopoverContent as $, PopoverBody as j } from "@chakra-ui/react";
import { forwardRef as H, useState as c, useEffect as L, useCallback as M } from "react";
import { useDebouncedCallback as N } from "use-debounce";
import { Input as R } from "../Input/Input.mjs";
import { AutoSuggestionContext as U } from "./AutoSuggestionContext.mjs";
import { AutoSuggestionList as V } from "./AutoSuggestionList.mjs";
import { AutoSuggestionStatus as W } from "./AutoSuggestionStatus.mjs";
import { getSuggestionDisplayValue as v } from "./autoSuggestionFunctions.mjs";
const q = H(
  (k, z) => {
    const {
      name: d,
      "data-testid": p,
      id: u = d,
      formInput: w,
      onSelectOption: n,
      options: l,
      renderOption: A,
      ...C
    } = k, [m, a] = c(!1), [e, h] = c([]), x = N(() => h([]), 100), [t, i] = c(-1), D = w || R, y = B("AutoSuggestion");
    L(() => {
      l && l.length > 0 ? (h(l), a(!0)) : (a(!1), x());
    }, [l]);
    const g = () => {
      i(-1);
    }, I = () => {
      a(!1), g();
    }, P = () => {
      e.length > 0 && a(!0);
    }, S = M(
      (o) => {
        if (e.length > 1) {
          if (o.type === "mousedown") {
            const s = o.currentTarget.id.match(/.*-(\d+)/);
            if (s && s.length > 1) {
              const f = parseInt(s[1]), K = v(
                e[f].value,
                e[f].suggestion
              );
              n == null || n(e[f].value, K), g();
            }
          } else if (o.type === "keydown") {
            const s = v(
              e[t].value,
              e[t].suggestion
            );
            n == null || n(e[t].value, s), g();
          }
        }
      },
      [t, n, e]
    ), b = (o) => {
      if (m)
        if (o.key === "ArrowUp")
          if (t > 0) {
            const s = t - 1;
            i(s);
          } else
            t === 0 && i(e.length - 1);
        else if (o.key === "ArrowDown")
          if (t < e.length - 1) {
            const s = t + 1;
            i(s);
          } else
            t === e.length - 1 && i(0);
        else
          o.key === "Home" ? i(0) : o.key === "End" ? i(e.length - 1) : o.key === "Enter" && t !== -1 && S(o);
    };
    return /* @__PURE__ */ r(
      U.Provider,
      {
        value: { dataTestId: p, handleSelection: S, id: u, keyedSuggestion: t, renderOption: A, suggestions: e },
        children: /* @__PURE__ */ T(E, { isOpen: m, matchWidth: !0, gutter: 4, autoFocus: !1, children: [
          /* @__PURE__ */ r(F, { children: /* @__PURE__ */ r(
            D,
            {
              name: d,
              id: u,
              "data-testid": p,
              ...C,
              autoComplete: "off",
              onBlur: I,
              onFocus: P,
              onKeyDown: b,
              ...e && t > -1 && {
                "aria-activedescendant": `${u}-suggestion-${t}`
              },
              spellCheck: "false",
              autoCorrect: "off",
              "aria-autocomplete": "list",
              "aria-owns": `${u}-suggestions`
            }
          ) }),
          /* @__PURE__ */ r(W, {}),
          /* @__PURE__ */ r($, { sx: y.content, children: /* @__PURE__ */ r(j, { sx: y.body, children: /* @__PURE__ */ r(V, {}) }) })
        ] })
      }
    );
  }
);
q.displayName = "AutoSuggestion";
export {
  q as AutoSuggestion
};
